import { useMemo } from 'react';
import { StripeAccountContext, StripeAccountContextValues } from '@hooks/useStripeAccount';
import useUser from '@hooks/useUser';
import useWatchStripeAccount from '@hooks/useWatchStripeAccount';

export default function StripeAccountProvider({
    children,
}: {
    children: React.JSX.Element;
}): React.JSX.Element {
    const { user } = useUser();

    // encapsulate stripe info fetch/watching so we can re-use it in the event/team provider too..
    const userStripeState = useWatchStripeAccount(user?.id, `StripeAccountProvider`);

    const stripeAccountContext: StripeAccountContextValues = useMemo(() => {
        return userStripeState;
    }, [userStripeState]);

    return (
        <StripeAccountContext.Provider value={stripeAccountContext}>
            {children}
        </StripeAccountContext.Provider>
    );
}
